import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6eebdd34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "deco" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "highlight" }

import { watchEffect } from 'vue';
import { useGame, useBase } from '@/store';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const baseStore = useBase();
const { errorMsg } = storeToRefs(baseStore);
const { handleError } = baseStore;

const gameStore = useGame();
const { login } = gameStore;
const { isInitReady } = storeToRefs(gameStore);

watchEffect(() => {
  if (isInitReady.value && errorMsg.value.length === 0) {
    handleError({ error: 'ERROR__LOGIN_FIRST' });
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _hoisted_4,
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('HOME__EVENT_TITLE__LEFT')), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('HOME__EVENT_TITLE__RIGHT')), 1)
    ]),
    _withDirectives(_createElementVNode("button", {
      class: "login",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(login)()))
    }, [
      _createElementVNode("span", null, _toDisplayString(_ctx.$t('HOME__LOGIN_BUTTON')), 1)
    ], 512), [
      [_vShow, _unref(isInitReady)]
    ])
  ]))
}
}

})